import React, { createContext, useReducer, useEffect } from "react";
import AppReducer from "./AppReducer";

const initialState = {
  currentSpotlight: null,
  spotlights: [],
  userData: null,
  workspaces: [],
  currentWorkspace: null,
};

export const GlobalContext = createContext(initialState);

//----------------------------------------------------------------------------
const localState = JSON.parse(localStorage.getItem("state"));

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, localState || initialState);

  useEffect(() => {
    localStorage.setItem("state", JSON.stringify(state));
    // console.log(JSON.parse(localStorage.getItem("state")));
  }, [state]);

  // Actions

  function doLogin(stateData) {
    dispatch({
      type: "LOGIN",
      stateData,
    });
  }

  function logOut() {
    dispatch({
      type: "LOGOUT",
      initialState,
    });
  }

  function initUser(userData) {
    dispatch({
      type: "INIT_USER",
      userData,
    });
  }

  function addWorkspace(workspaceData) {
    dispatch({
      type: "ADD_WORKSPACE",
      workspaceData,
    });
  }

  function addSpotlight(spotlightData) {
    dispatch({
      type: "ADD_SPOTLIGHT",
      spotlightData,
    });
  }

  function setSpotlights(spotlightArray) {
    dispatch({
      type: "SET_SPOTLIGHTS",
      spotlightArray,
    });
  }

  function setCurrentSpotlight(spotlight) {
    dispatch({ type: "SET_CURRENT_SPOTLIGHT", spotlight });
  }

  function clearCurrentSpotlight() {
    dispatch({ type: "CLEAR_CURRENT_SPOTLIGHT" });
  }

  function setActiveSpotlight() {
    dispatch({ type: "SET_ACTIVE_SPOTLIGHT" });
  }

  function deactivateSpotlight() {
    dispatch({type: "DEACTIVATE_SPOTLIGHT"});
  }

  function updateUser(updatedUserData) {
    dispatch({ type: "UPDATE_USER", updatedUserData });
  }

  async function setCurrentWorkspace(currentWorkspace) {
    await dispatch({ type: "SET_CURRENT_WORKSPACE", currentWorkspace});
  }

  function updateWorkspace(name) {
    dispatch({ type: "UPDATE_WORKSPACE", name });
  }

  function setWorkspaces(workspaces) {
    dispatch({
      type: "SET_WORKSPACES",
      workspaces,
    });
  }

  function setRoles(roles) {
    dispatch({
      type: "SET_ROLES",
      roles,
    });
  }

  function setCurrentPlan(planId) {
    dispatch({
      type: "SET_CURRENT_PLAN",
      planId,
    });
  }

  return (
    <GlobalContext.Provider
      value={{
        currentWorkspace: state.currentWorkspace,
        userData: state.userData,
        workspaces: state.workspaces,
        spotlights: state.spotlights,
        currentSpotlight: state.currentSpotlight,
        doLogin,
        logOut,
        addWorkspace,
        initUser,
        addSpotlight,
        setSpotlights,
        setCurrentSpotlight,
        setActiveSpotlight,
        deactivateSpotlight,
        clearCurrentSpotlight,
        updateUser,
        updateWorkspace,
        setCurrentWorkspace,
        setWorkspaces,
        setCurrentPlan,
        setRoles,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
